import React from "react";
import { Link } from "react-router-dom";

const Portfolio = () => {
  return (
    <div className="my-4 py-4" id="portfolio">
      {/* Title */}
      <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">
        Products
      </h2>

      <div className="flex justify-center">
        <div className="w-24 border-b-4 border-blue-900 mb-8"></div>
      </div>

      {/* Grid */}
      <div className="px-4" data-aos="fade-down" data-aos-delay="600">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

          <ProductCard
            title="Overseas Education CRM"
            description="An Overseas Education CRM is designed for study-abroad consultants and educational agencies to manage the complete student lifecycle—from enquiry to university admission and visa completion.

It streamlines counselling, application tracking, document management, and communication, improving efficiency, transparency, and conversion rates."
          />

          <ProductCard
            title="Environment Lab CRM"
            description="An Environment Lab CRM is built for environmental testing laboratories to manage clients, samples, workflows, compliance, and reporting.

It covers the entire lab lifecycle—from enquiry and sample collection to testing, reporting, invoicing, and ISO/IEC 17025 compliance."
          />

          <ProductCard
            title="IoT-Based Application"
            description="An IoT-based application connects sensors and smart devices to a centralized platform for real-time data collection and monitoring.

It enables automation, intelligent processing, dashboards, alerts, and actionable insights to improve efficiency and decision-making."
          />

          <ProductCard
            title="Hospital Management CRM"
            description="A Hospital Management CRM helps manage patient relationships, clinical workflows, and administrative operations.

It automates appointments, registration, treatment tracking, billing, and follow-ups—enhancing patient experience and operational efficiency."
          />

          <ProductCard
            title="Smart Glass–Based Surgical Training"
            description="This system enables junior doctors to receive real-time surgical training from senior surgeons using smart glasses.

Live procedures are streamed from the operation theatre with annotations, interaction, and hands-free guidance—ensuring immersive and practical surgical education without disrupting operations.

Sch"
          />

          <ProductCard
            title="AI-Based Defect Detection System"
            description="An AI-based defect detection system uses computer vision and machine learning to automatically identify cracks, surface defects, dimensional errors, and anomalies in products.

It operates in real time, reducing human error, increasing inspection speed, ensuring consistent quality, and minimizing production losses in manufacturing environments."
          />

          <ProductCard
            title="Payroll Management System"
            description="The Payroll Management System automates employee salary processing, tax calculations, deductions, and payslip generation.

It improves payroll accuracy, reduces manual effort, ensures statutory compliance, and integrates seamlessly with attendance, HR, and accounting systems using secure and scalable APIs."
          />

          <ProductCard
            title="Event Management System"
            description="An Event Management System helps plan, organize, and manage events such as weddings, conferences, and corporate functions.

It handles bookings, schedules, vendors, budgets, and workflows in one platform, ensuring smooth coordination, reduced stress, and a memorable event experience for both organizers and clients."
          />

        </div>
      </div>
    </div>
  );
};

/* Reusable Card Component */
const ProductCard = ({ title, description }) => {
  return (
    <div className="bg-white h-full flex flex-col transition-all duration-300 hover:scale-105 rounded-lg shadow-2xl p-5">
      <h4 className="font-semibold text-xl text-center mb-4 min-h-[56px]">
        {title}
      </h4>

      <p className="text-md font-medium leading-6 text-justify flex-grow">
        {description}
      </p>

      <div className="flex justify-center mt-6">
        <Link
          to="/get-demo"
          className="text-white bg-blue-900 hover:bg-blue-800 w-full text-center px-6 py-3 rounded-xl shadow-xl"
        >
          Schedule Demo
        </Link>
      </div>
    </div>
  );
};

export default Portfolio;
